module.exports = __webpack_public_path__ + "img/m5_t1_bg.01b54e56.svg";